import HideHeaderButtons from 'src/javascripts/components/tables/checkboxes/HideHeaderButtons';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

// Bulk expott using selected record IDs from a table
export default function(tableId) {

	$('.export-bulk').off().on('click', function() {
	  let url = $(this).data('url');
	  let params = {};
	  params['record_ids'] = $('#' + tableId).data('record-ids');
	  
	  // Check if URL already has parameters
	  let separator = url.includes('?') ? '&' : '?';
	  let finalUrl = url + separator + $.param(params);
	  
	  $.ajax({
	    type: 'POST',
	    dataType: 'application/json',
	    url: finalUrl,
	    complete(result) { 
	      let response = JSON.parse(result.responseText);
	      $('#' + tableId).DataTable().ajax.reload();
	      if (response.status === 200) {
	        ToastCustom({title: 'Success', message: response.message, delay: 8000, autohide: true, type: 'success'});
	      } else {
	        ToastCustom({title: 'Error', message: response.message, delay: 8000, autohide: true, type: 'warning'});
	      }
	      HideHeaderButtons(tableId);
	    }
	  });
	})

}